import { render, staticRenderFns } from "./PowerdataReports.vue?vue&type=template&id=2d77d211&scoped=true"
import script from "./PowerdataReports.vue?vue&type=script&lang=js"
export * from "./PowerdataReports.vue?vue&type=script&lang=js"
import style0 from "./PowerdataReports.vue?vue&type=style&index=0&id=2d77d211&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77d211",
  null
  
)

export default component.exports